module.exports = __webpack_public_path__ + "static/media/RRARAppleFeature-small.3ff41928.JPG";